import { jsx as _jsx } from "react/jsx-runtime";
const toneClass = {
    default: '',
    primary: 'dhk8-badge--primary',
    success: 'dhk8-badge--success',
    warning: 'dhk8-badge--warning',
    danger: 'dhk8-badge--danger',
};
export function Badge({ tone = 'default', children, className }) {
    const classes = ['dhk8-badge', toneClass[tone], className ?? ''].filter(Boolean).join(' ');
    return _jsx("span", { className: classes, children: children });
}
//# sourceMappingURL=Badge.js.map